import { render } from "./MainSystemEspecificAcess.vue?vue&type=template&id=5dea7f3c&scoped=true"
import script from "./MainSystemEspecificAcess.vue?vue&type=script&lang=js"
export * from "./MainSystemEspecificAcess.vue?vue&type=script&lang=js"

import "./MainSystemEspecificAcess.vue?vue&type=style&index=0&id=5dea7f3c&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dea7f3c"]])

export default __exports__